<!--
    BD LV Decision Table — Wave 3
    Listet ausschließlich LV-Verträge des Mahnvorgangs und übergibt die ausgewählten
    Verträge an den SB-Arbeitsvorrat (Prämienfreistellung / Rückkauf / Mahnverzicht / Sonstiges).
    @ticket TM-1000001786
-->
@if (initialized) {
    <div class="flex flex-column gap-3">

        <!-- Header -->
        <div class="flex align-items-center gap-2">
            <i class="fa-light fa-shield-heart text-primary"></i>
            <span class="font-semibold text-lg">LV-Entscheidungen</span>
        </div>

        <!-- C19: Mischkonto-Aufteilung sichtbar (LV → SB-Liste / Rest → regulär) -->
        @if (isMixedAccount) {
            <div class="surface-50 border-round p-3 text-sm flex align-items-start gap-2">
                <i class="fa-light fa-code-branch text-primary mt-1"></i>
                <div class="flex flex-column gap-1">
                    <span class="font-semibold">Mischkonto erkannt</span>
                    <span class="text-color-secondary">
                        {{ lvCount }} LV-Posten → SB-Arbeitsvorrat,
                        {{ nonLvCount }} übrige Posten → regulärer Mahnlauf.
                    </span>
                </div>
            </div>
        }

        <!-- Error -->
        @if (errorMessage) {
            <p-message severity="error" [text]="errorMessage" styleClass="w-full"></p-message>
        }

        <!-- Success -->
        @if (success) {
            <p-message severity="success"
                       text="LV-Verträge wurden an den SB-Arbeitsvorrat übergeben."
                       styleClass="w-full"></p-message>
        }

        <!-- Empty state -->
        @if (rows.length === 0) {
            <div class="surface-card border-round p-4 text-center">
                <i class="fa-light fa-folder-open text-3xl text-400 mb-2"></i>
                <p class="m-0 text-600">Keine LV-Verträge zur Bearbeitung verfügbar.</p>
            </div>
        }

        <!-- Decision table -->
        @if (rows.length > 0) {
            <div class="surface-card border-round overflow-hidden">
                <p-table [value]="rows"
                         styleClass="p-datatable-sm p-datatable-striped">

                    <ng-template pTemplate="header">
                        <tr>
                            <th class="w-3rem text-center">
                                <p-checkbox [ngModel]="allSelected"
                                            (onChange)="selectAll($event.checked)"
                                            [binary]="true">
                                </p-checkbox>
                            </th>
                            <th class="w-6rem">Vertrag-ID</th>
                            <th>Vertrags-Name</th>
                            <th class="w-9rem text-right">Mahn-Saldo</th>
                            <th class="w-14rem">Aktion</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-row>
                        <tr [class.bd-row-submitted]="row.submitted">
                            <td class="text-center">
                                <p-checkbox [(ngModel)]="row.selected"
                                            [binary]="true"
                                            [disabled]="row.submitted">
                                </p-checkbox>
                            </td>
                            <td class="font-mono text-sm">{{ row.contractId }}</td>
                            <td>{{ row.contractName }}</td>
                            <td class="text-right font-medium">
                                {{ row.dunningBalance | currency:'EUR':'symbol':'1.2-2':'de-DE' }}
                            </td>
                            <td>
                                <p-select [options]="decisionOptions"
                                          optionLabel="label"
                                          optionValue="value"
                                          [(ngModel)]="row.selectedAction"
                                          placeholder="Auswählen…"
                                          [disabled]="row.submitted"
                                          appendTo="body"
                                          styleClass="w-full">
                                </p-select>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>

            <!-- Submit Button -->
            <div class="flex justify-content-end">
                <p-button label="An SB-Arbeitsvorrat übergeben"
                          icon="fa-light fa-paper-plane"
                          [loading]="submitting"
                          [disabled]="selectedRows.length === 0"
                          (onClick)="submitTransfer()">
                </p-button>
            </div>
        }
    </div>
}
